export const setLocalStorageIfExists = (key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    localStorage.setItem(key, value);
  }
};